<ngx-extended-pdf-viewer
    [src]="data.pdfFile"
    [width]="'100%'"
    [height]="'90vh'"
    [showToolbar]="false"
    [showOpenFileButton]="false"
    [showPrintButton]="false"
    [showDownloadButton]="false"
    [useInlineScripts]="false"
    [showHighlightEditor]="false"
    [showDrawEditor]="false"
    [showStampEditor]="false"
    [showTextEditor]="false"></ngx-extended-pdf-viewer>
